<template>
  <section class="offerDetailAccommodationList defaultSectionPaddings">
    <div class="container--Medium">
      <h2 v-text="data.title" />
      
      <div v-if="page?.accommodations?.length" class="offerDetailAccommodationList__Offers">
        <template v-if="page.accommodations.length === 1">
          <PropertyItem :property="accommodations[0]" vertical without-border without-book-button without-price />
        </template>
        <PropertyItem v-else v-for="accommodation in accommodations" :property="accommodation" without-border without-price />
      </div>
    </div>
  </section>
</template>

<script setup>
  const props = defineProps({ data: {}});
  const { page } = usePage();
  const { accommodationsData } = useSetup();
  const dataLayerList = useState('dataLayerList');
  const accommodations = (page.value?.accommodations || []).map(item => accommodationsData.value[item]);

  let ecommerceItems = [];
  ecommerceItems = accommodations.map((accommodation, index) => {
    return {
      'item_id': accommodation.id,
      'item_name': accommodation.name,
      'item_category': accommodation.kind === 'CAMP' ? 'Campsites' : 'Hotels and resorts',
      'item_category2': accommodation.place?.name,
      'item_brand': accommodation.brand?.name,
      'item_list_name': props.data.title,
      'item_list_id': 'Special offers',
      'index': index + 1,
    }
  });

  onMounted(() => {
    dataLayerList.value = ecommerceItems;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      'event': 'view_item_list',
      'ecommerce': {
        'items': ecommerceItems,
      },
    });
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_offerDetailAccommodationList.scss');
</style>